import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-master-disclaimer-dialog',
  templateUrl: './master-disclaimer-dialog.component.html',
  styleUrls: ['./master-disclaimer-dialog.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class MasterDisclaimerDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<MasterDisclaimerDialogComponent>,) {
  }

  public ngOnInit(): void {
  }

  public proceed(): void {
    this.dialogRef.close('proceed');
  }

  public cancel(): void {
    this.dialogRef.close('cancel');
  }
}
